import { ProductApi } from '@linktivity/ars-neo';
import config from './config';

const productApi = new ProductApi(config);

export default productApi;
